import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { Alert, Button, Card, DatePicker, Form, Input, Select, Space } from "antd"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createCode, getBusinessClients } from "../../store/slices/codeSlice";

const AddCode = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const { businessClients } = useSelector((state) => state?.code)
    useEffect(() => {
        dispatch(getBusinessClients())
    }, [dispatch])
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const resultAction = await dispatch(createCode(values))
            if (createCode.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Code created successfully');
                setAlertType('success');
                form.resetFields();
                setTimeout(() => {
                    setAlertMessage('')
                }, 4000)
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error creating code');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error creating code');
            setAlertType('error');
        } finally {
            setLoading(false);
        }
    }
    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Code</h1>
            <Card title="Add Code" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                >
                    <Form.Item
                        label="Code"
                        name="code"
                        rules={[{ required: true, message: 'Please input code!' }]}
                    >
                        <Input placeholder="Enter code" />
                    </Form.Item>
                    <Form.Item
                        label="Start Date"
                        name="start_date"
                        rules={[{ required: true, message: 'Please select start date!' }]}
                    >
                        <DatePicker placeholder="Enter start date" style={{ width : "100%" }} />
                    </Form.Item>
                    <Form.Item
                        label="End Date"
                        name="end_date"
                        rules={[{ required: true, message: 'Please select end date!' }]}
                    >
                        <DatePicker placeholder="Enter end date" style={{ width : "100%" }} />
                    </Form.Item>
                    <Form.Item
                        label="No of Users"
                        name="no_of_users"
                        rules={[{ required: true, message: 'Please input no of users!' }]}
                    >
                        <Input placeholder="Enter no of users" />
                    </Form.Item>
                    <Form.Item
                        label="Business Client"
                        name="business_client"
                        rules={[{ required: true, message: 'Please select Business Client' }]}
                    >
                        <Select
                            placeholder="Select Business Client"
                            options={businessClients?.data?.map((data) => ({
                                value: `${data?._id}`,
                                label: `${data?.name}`,
                            }))}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
}

export default AddCode